export class Reports {
    static readonly GET_DATASET_DATA_USING_IDS_V2 =
        '/api/Reports/httpPost_GetDatasetDataUsingIDsV2';

    static readonly GET_CHART_DATA_USING_IDS_V2 =
        '/api/Reports/httpPost_GetChartDataUsingIDsV2';
}

export default Reports;
